<template>
  <base-modal
    hideFooter
    :size="'lg'"
    @hidden="$emit('onCloseModal')"
    @show="onModalOpen"
    :modalId="'manage-stock'"
  >
    <template #modal-header>
      <div class="head-label"><b>Manage Stock : </b>{{ formReward.name }}</div>
    </template>
    <div class="w-100 px-2">
      <b-row class="pl-4 pr-2 pb-2">
        <b-col cols="12" lg="8" sm="12">
          <b-row>
            <b-col cols="12">
              <b-form-group
                :label="'Status'"
                label-for="status"
                label-class="font-medium-5"
              >
                <div class="d-flex align-items-center">
                  <feather-icon
                    icon="CircleIcon"
                    class="mr-2"
                    :class="resolveStatusClass(formReward.status)"
                  />

                  <span class="font-medium-5">{{
                    resolveStatusLabel(formReward.status)
                  }}</span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6" sm="12">
              <b-row>
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Reference'"
                    label-for="reference"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      id="reference"
                      required
                      disabled
                      v-model="formReward.reference"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="6" sm="12">
              <b-row class="justify-content-end">
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Privilege Type'"
                    label-for="reward-type"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      id="reward-type"
                      required
                      disabled
                      v-model="formReward.privilegeType"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6" sm="12">
              <b-row>
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Code Type'"
                    label-for="code-type"
                    label-class="font-medium-5"
                  >
                    <b-form-input
                      id="code-type"
                      required
                      disabled
                      v-model="formReward.codeType"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="6" sm="12">
              <b-row class="justify-content-end">
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Stock Mode'"
                    label-for="stock-mode"
                    label-class="font-medium-5"
                  >
                    <v-select
                      v-model="formManageStock.stockMode"
                      class="select-format-container font-medium-5 bg-dropdown"
                      :class="[
                        formManageStock.stockMode
                          ? 'select-format-selected'
                          : null,
                        {},
                      ]"
                      :reduce="(option) => option.value"
                      :options="stockModeOptions"
                      required
                      :disabled="disabledForm.stockMode"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6" sm="12">
              <b-row>
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Mode'"
                    label-for="mode"
                    label-class="font-medium-5"
                  >
                    <v-select
                      v-model="formManageStock.modeQty"
                      class="select-format-container font-medium-5 bg-dropdown"
                      :class="[
                        formManageStock.modeQty
                          ? 'select-format-selected'
                          : null,
                        {},
                      ]"
                      :reduce="(option) => option.value"
                      :options="modeAddQuantity"
                      required
                      :disabled="disabledForm.modeQty"
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="6" sm="12">
              <b-row class="justify-content-end">
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Removal Strategy'"
                    label-for="removal-strategy"
                    label-class="font-medium-5"
                  >
                    <v-select
                      v-model="formManageStock.removalStrategy"
                      class="select-format-container font-medium-5 bg-dropdown"
                      :class="[
                        formManageStock.removalStrategy
                          ? 'select-format-selected'
                          : null,
                        {},
                      ]"
                      :reduce="(option) => option.value"
                      :options="removalOptions"
                      required
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col cols="12" lg="12" sm="12">
              <b-row>
                <b-col cols="12" lg="12" sm="12">
                  <b-row>
                    <b-col cols="12" lg="3" sm="4">
                      <b-form-radio
                        v-model="selected"
                        name="mode-radios"
                        :value="QUANTITY_ADD"
                        class="custom-radio-group font-medium-5"
                        >Import</b-form-radio
                      >
                    </b-col>
                    <b-col cols="12" lg="12" sm="12" class="pl-3">
                      <b-form-group
                        :label="'Import Mode'"
                        label-for="import-mode"
                        label-class="font-medium-5"
                      >
                        <v-select
                          v-model="formManageStock.importMode"
                          class="select-format-container font-medium-5 bg-dropdown"
                          :class="[
                            formManageStock.importMode
                              ? 'select-format-selected'
                              : null,
                            {},
                          ]"
                          :reduce="(option) => option.value"
                          :options="modeImport"
                          required
                          :clearable="false"
                          :disabled="(selected == QUANTITY_WITHDRAW || !formReward.isImportAvailable)"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="12" sm="12" class="pl-3">
                      <b-form-group
                        :label="'Import File'"
                        label-for="import-file"
                        label-class="font-medium-5"
                      >
                        <b-form-input
                          id="import-file"
                          class="import-file"
                          required
                          disabled
                          v-model="formFile.name"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="12" lg="12" sm="12" class="pl-3">
                      <div class="d-flex justify-content-end">
                        <b-button @click="downloadTemplate" class="mr-4 template-btn"> <download class="icon-download-template"/> Download Template</b-button>
                        <upload-button @onUpload="onUpload" :disabledBtn="(selected == QUANTITY_WITHDRAW || !formReward.isImportAvailable)" />
                      </div>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="12" sm="12" class="pt-2" v-if="!qtyTotal == 0">
              <b-row>
                <b-col cols="12" lg="6" sm="6">
                  <b-row>
                    <b-col cols="12" lg="12" sm="12">
                      <b-form-radio
                        v-model="selected"
                        name="mode-radios"
                        :value="QUANTITY_WITHDRAW"
                        class="custom-radio-group font-medium-5"
                        >Withdraw</b-form-radio
                      >
                    </b-col>
                    <b-col cols="12" lg="7" sm="12" class="pl-3 pt-1">
                      <input-spin
                        :mode="
                          selected == QUANTITY_WITHDRAW ? 'remove' : 'disabled'
                        "
                        :numValue="quantityValue.withdraw"
                        @update-number="updateWithdraw"
                        :key="selected"
                        :isInputDisabled="false"
                      />
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" lg="6" sm="6">
                  <b-row class="justify-content-end">
                    <b-col cols="12" lg="10" sm="12">
                      <b-form-group
                        :label="'Removal Strategy'"
                        label-for="removal-strategy"
                        label-class="font-medium-5"
                      >
                        <v-select
                          v-model="formManageStock.removalExport"
                          class="select-format-container font-medium-5 "
                          :class="[
                            formManageStock.removalExport
                              ? 'select-format-selected'
                              : null,
                            {},
                          ]"
                          :reduce="(option) => option.value"
                          :options="removalOptions"
                          required
                          :clearable="false"
                          :disabled="!(selected == QUANTITY_WITHDRAW)"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group
                :label="'Note'"
                label-for="note"
                label-class="font-medium-5"
              >
                <b-form-textarea
                  id="note"
                  rows="3"
                  required
                  v-model="formReward.note"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12" lg="4" sm="12">
          <img-zoom-content
            :width="'100%'"
            :height="'175px'"
            :imageUrl="formReward.image"
          />
        </b-col>
      </b-row>
      <div v-if="!formReward.isImportAvailable" class="text-warning-import-export">You can import/export only 1 file at the same time.</div>
      <div class="mt-2 mb-2">
        <div class="d-flex justify-content-center">
          <cancel-button class="mr-1" @click.native="$emit('onCloseModal')" />
          <save-button
            :loading="loading.form"
            @click.native="onSubmitPrivilegeToInventory"
            :btnLabel="selected == QUANTITY_WITHDRAW ? 'Export':'Import'"
            :disabled="!formReward.isImportAvailable"
            class="ml-1"
          />
        </div>
      </div>
    </div>

    <b-row class="modal-body-container mb-1"> </b-row>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import useManageStockCouponExternal from "../hooks/useManageStockCouponExternal";
import ImgZoomContent from "../../inventory-privilege-history/components/ImgZoomContent.vue";
import InputSpin from "@/views/components/input-spin/InputSpin.vue";
import UploadButton from "@/views/components/button/UploadButton.vue";
import Download from '@/@core/components/svg/common/Download.vue';
import IconDownload from '@/assets/images/icons/IconDownload.png'
export default {
  components: { BaseModal, ImgZoomContent, InputSpin, UploadButton, Download , IconDownload},
  props: {
    rewardDetail: { type: Object, default: {} },
  },
  setup(props) {
    const {
      loading,
      formFile,
      formReward,
      qtyTotal,
      formManageStock,
      QUANTITY_ADD,
      QUANTITY_WITHDRAW,
      selected,
      quantityValue,
      stockModeOptions,
      removalOptions,
      modeAddQuantity,
      modeImport,
      disabledForm,
      onModalOpen,
      updateAddQuantity,
      updateWithdraw,
      onSubmitPrivilegeToInventory,
      resolveStatusLabel,
      resolveStatusClass,
      onUpload,
      downloadTemplate
    } = useManageStockCouponExternal(props);
    return {
      loading,
      formFile,
      formReward,
      qtyTotal,
      formManageStock,
      QUANTITY_ADD,
      QUANTITY_WITHDRAW,
      selected,
      quantityValue,
      stockModeOptions,
      removalOptions,
      modeAddQuantity,
      modeImport,
      disabledForm,
      onModalOpen,
      updateAddQuantity,
      updateWithdraw,
      onSubmitPrivilegeToInventory,
      resolveStatusLabel,
      resolveStatusClass,
      onUpload,
      downloadTemplate
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/pages/inventory/manage-stock.css";
@import "~@/assets/css/override-styles/radio.css";
</style>
